const initIframeResponsive = () => {

    if ($('body[data-template="resource-case-study"]').length) {
        const youtubeRegex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/g;

        $('iframe:not([data-parameters])').each((index, iframe) => {
            
            if (iframe.src.match(youtubeRegex)) {
                const iframeParent = $(iframe).parent();

                if (iframeParent) {

                    if (!$(iframeParent).hasClass('iframe-responsive-wrapper')) {
                        iframe.outerHTML = `<div class="iframe-responsive-wrapper">${iframe.outerHTML}</div>`;
                    }

                }
            }
        });
    }
    
};

export default initIframeResponsive;